import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import InhibitionTypeList from './inhibitionTypes/InhibitionTypeList';
import InhibitionTypeForm from './inhibitionTypes/InhibitionTypeForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addInhibitionTypesAction } from '../../actions/inhibitionTypesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const InhibitionTypes = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addInhibitionTypesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Persona Inhibición Tipos' 
                subtitle='Personas' 
                nodes={nodes}
                actions={actions}
                component={InhibitionTypeList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <InhibitionTypeForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default InhibitionTypes;